import { useId, useState, type ReactNode } from 'react'

interface Props {
  /** The label the help belongs to (also used for the button's accessible name). */
  label: string
  /** Explanation: what it means, which direction is good, a range only if defensible. */
  children: ReactNode
}

/** Label + small help icon; clicking (or Enter/Space) opens the explanation
 * BELOW the label — works on touch screens, unlike a hover-only tooltip
 * (fleet frontend standard 6a). */
export function HelpTip({ label, children }: Props) {
  const [open, setOpen] = useState(false)
  const id = useId()
  return (
    <span className="wnf-help">
      <span className="wnf-help__label">
        {label}
        <button
          type="button"
          className="wnf-help__btn"
          aria-expanded={open}
          aria-controls={id}
          aria-label={`What does ${label} mean?`}
          onClick={() => setOpen((o) => !o)}
        >
          ?
        </button>
      </span>
      {open && (
        <span id={id} className="wnf-help__text" role="note">
          {children}
        </span>
      )}
    </span>
  )
}
